module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img_m.aad286c29d9663b75a916b11f3a33d58.jpg";